import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import Decimal from 'decimal.js';

@Directive({
  selector: '[appPrecisionFormat]',
  standalone: false
})
export class PrecisionFormatDirective implements OnInit {

  @Input('appPrecisionFormat') precision = 2;

  constructor(
    private el: ElementRef,
    private control: NgControl,
  ) { }

  ngOnInit(): void { }

  @HostListener('blur') onBlur() {
    const value = this.el.nativeElement.value;
    value && this.formatAndSetValue(value);
  }

  private formatAndSetValue(value: any): void {
    if (typeof value === 'string') {
      value = value.replace(/[^0-9.-]+/g, '');
    }
    const numberValue: any = new Decimal((value));
    if (!isNaN(numberValue)) {
      const formattedValue = numberValue.toFixed(this.precision);
      if (this.control?.control) {
        this.control.control.setValue(formattedValue, { emitEvent: false });
      }
    }
  }

}
